import { memo, useRef, useState } from 'react'
import { Button, Toast } from '@ow/comps'
import { useAppEx } from '@vt/hooks'
import EmptyWithTbSelect from '../emptyWithTbSelect'
import Form from './form'

const Footer = ({ submit, cancel }) => {
  return (
    <div className="h-12 flex border-t justify-end items-center gap-2">
      <Button type="primary" onClick={submit}>
        保存
      </Button>
      <Button stroke onClick={cancel}>
        取消
      </Button>
    </div>
  )
}

const LogicEditor = ({ data, onEdit, onSelect }) => {
  const { tbs } = useAppEx()
  const [newData, setNewData] = useState(null)

  const formRef = useRef()

  const onTbSelect = (tbId) => {
    if (!tbId) return
    setNewData({ tbId, queries: [] })
  }

  const current = data || newData

  if (!current) {
    return (
      <div className="w-1/2">
        <EmptyWithTbSelect tbs={tbs} onTbSelect={onTbSelect} />
      </div>
    )
  }

  const submit = async () => {
    const res = await formRef.current.trigger()
    const formData = formRef.current.getValues()
    if (res && formData.queries?.length) {
      onEdit({ ...current, ...formData })
      setNewData(null)
    } else {
      Toast.error({
        title: '请填写完整规则信息',
      })
    }
  }

  const cancel = () => {
    onSelect(null)
    setNewData(null)
  }

  return (
    <div className="w-1/2 flex flex-col">
      <Form ref={formRef} data={current} />
      <Footer submit={submit} cancel={cancel} />
    </div>
  )
}

export default memo(LogicEditor)
